export default "__VITE_ASSET__rRUMhR8I__"